import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { getNbrCotisants } from "../../../../actions/thunks/statistics";
import { connect } from "react-redux";
import { S3_GEOJSON_FOLDER_URL } from "Config";

const BelgiumCityMap = ({ eventStatsFilter, cityPercentageData, firstVariant, secondVariant, thirdVariant }) => {
  const mapRef = useRef(null);
  const geoJsonCacheRef = useRef(null);
  const geoJsonPromiseRef = useRef(null);

  const getColorBasedOnPercentage = (percentage) => {
    return percentage > firstVariant
      ? "#2d74d0"
      : percentage > secondVariant
        ? "#4582e4"
        : percentage > thirdVariant
          ? "#88b0ed"
          : "#dddddd";
  };

  const getCityStyle = (feature, cityPercentageData) => {
    const cityName = feature.properties.name;
    const nbrInscription = cityPercentageData && cityPercentageData[cityName] ? cityPercentageData[cityName][0] : 0;

    return {
      color: "#757575",
      weight: 0.8,
      opacity: 1,
      fillColor: getColorBasedOnPercentage(nbrInscription),
      fillOpacity: 1,
    };
  };

  const addCityTooltip = (feature, layer, cityPercentageData) => {
    const cityName = feature.properties.name;
    const nbrInscription = cityPercentageData && cityPercentageData[cityName] ? cityPercentageData[cityName][0] : 0;
    const ca = cityPercentageData && cityPercentageData[cityName] ? `${cityPercentageData[cityName][1] / 100} €` : '0 €';
    layer.bindTooltip(`${cityName}: ${nbrInscription}, ${ca}`);
  };

  const addGeoLayer = (geoData) => {
    L.geoJSON(geoData, {
      style: (feature) => getCityStyle(feature, cityPercentageData),
      onEachFeature: (feature, layer) => addCityTooltip(feature, layer, cityPercentageData),
    }).addTo(mapRef.current);
  };

  // componentDidMount
  useEffect(() => {
    mapRef.current = L.map("map").setView([50.5, 4.5], 7);

    if (geoJsonCacheRef.current) {
      addGeoLayer(geoJsonCacheRef.current);
      return;
    }

    if (!geoJsonPromiseRef.current) {
      geoJsonPromiseRef.current = fetch(
        `${S3_GEOJSON_FOLDER_URL}/billing/geojson/belgium.geojson`
      ).then(res => res.json());
    }

    geoJsonPromiseRef.current.then(data => {
      geoJsonCacheRef.current = data;
      addGeoLayer(data);
    });

    // componentWillUnmount
    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  // componentDidUpdate
  useEffect(() => {
    if (!mapRef.current) return;

    mapRef.current.eachLayer((layer) => {
      if (layer instanceof L.GeoJSON) {
        mapRef.current.removeLayer(layer);
      }
    });

    if (geoJsonCacheRef.current) {
      addGeoLayer(geoJsonCacheRef.current);
    }
  }, [cityPercentageData, firstVariant, secondVariant, thirdVariant]);

  return <div id="map" style={{ width: "100%", height: "300px", zIndex: 1 }} />;
};

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {
  getNbrCotisants,
};

export default connect(mapStateToProps, mapDispatchToProps)(BelgiumCityMap);


// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/BelgiumMap.js